import {
  BiLegendPosition,
  kBiVizStyleDefaults,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kPositions: Array<{ value: BiLegendPosition; label: string }> = [
  { value: BiLegendPosition.Top, label: '上方' },
  { value: BiLegendPosition.Bottom, label: '下方' },
  { value: BiLegendPosition.Right, label: '右侧' },
];

/** Whether the legend shows, and where. */
export const LegendOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const legend = style?.legend ?? kBiVizStyleDefaults.legend;
  const set = (patch: Partial<typeof legend>) =>
    onChange(biWithStyleOption(style, 'legend', { ...legend, ...patch }));
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.legend}
      onReset={
        style?.legend
          ? () => onChange(biWithStyleOption(style, 'legend', undefined))
          : null
      }
    >
      <StyleRow label="显示">
        <BiChip
          label={style?.legend ? '显示' : '自动'}
          selected={legend.show}
          onPress={() => set({ show: true })}
        />
        <BiChip
          label="隐藏"
          selected={!legend.show}
          onPress={() => set({ show: false })}
        />
      </StyleRow>
      {legend.show ? (
        <StyleRow label="位置">
          {kPositions.map(position => (
            <BiChip
              key={position.value}
              label={position.label}
              selected={legend.position === position.value}
              onPress={() => set({ position: position.value })}
            />
          ))}
        </StyleRow>
      ) : null}
    </StyleGroup>
  );
});
